export default __webpack_public_path__ + "images/eaa6b0d5c4b755a1c5f442a5b31d3913.svg";